module.exports = __webpack_public_path__ + "assets/img/bg.1e62e5d6.jpg";